interface CommonButtonProps {
  text: string;
  onClick?: () => void;
  className?: string;
  disabled?: boolean;
}

export function CommonButton({
  text,
  onClick,
  className = '',
  disabled = false,
}: CommonButtonProps): JSX.Element {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`w-full bg-primary-400 text-white font-kanit font-bold text-base py-3.5 rounded-xl shadow-soft mt-3 transition-all duration-200 hover:opacity-90 active:scale-[0.98] disabled:opacity-50 disabled:cursor-not-allowed ${className}`}
    >
      {text}
    </button>
  );
} 